import { Injectable } from "@angular/core";

import { MapperInterface } from "./mapper-inteface";

import { CaricaNuovaVersioneDocumentoRequestDTO } from "../dto/carica-nuova-versione-documento-requestDTO";

import { CaricaNuovaVersioneDocumentoRequestVO } from "../vo/carica-nuova-versione-documento-requestVO";
import { MapperDocumentoGescor } from "./gescor/mapper-documento-gescor";

@Injectable({
    providedIn: "root"
})
export class MapperCaricaNuovaVersioneDocumento implements MapperInterface<CaricaNuovaVersioneDocumentoRequestDTO, CaricaNuovaVersioneDocumentoRequestVO> {
    constructor(
        private mapperDocumentoGescor: MapperDocumentoGescor //   private mapperRecapito: MapperRecapito
      ) {}
    convertVoToDto(vo: CaricaNuovaVersioneDocumentoRequestVO): CaricaNuovaVersioneDocumentoRequestDTO {
        if (vo != null) {
            const dto = new CaricaNuovaVersioneDocumentoRequestDTO();
            dto.idDocumento = vo.idDocumento;
            dto.riferimentiRepository = this.mapperDocumentoGescor.convertVoToDto(vo.riferimentiRepository);
             return dto;
        } else {
            return null;
        }
    }
    convertDtoToVo(t: CaricaNuovaVersioneDocumentoRequestDTO): CaricaNuovaVersioneDocumentoRequestVO {
        throw new Error("Method not implemented.");
    }
    convertListVoToDto(e: CaricaNuovaVersioneDocumentoRequestVO[]): CaricaNuovaVersioneDocumentoRequestDTO[] {
        throw new Error("Method not implemented.");
    }
    convertListDtoToVo(t: CaricaNuovaVersioneDocumentoRequestDTO[]): CaricaNuovaVersioneDocumentoRequestVO[] {
        throw new Error("Method not implemented.");
    }


}